import "./styles/main.scss";

import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import createSagaMiddleware from "redux-saga";

import App from "./app/App";
import { base } from "./app/base/actions";
import createRootReducer from "./root-reducer";
import rootSaga from "./root-saga";
import { getBasePath } from "./utils";

let basename = "";
if (process.env.NODE_ENV !== "development") {
  // basename defines a url prefix for production deployment
  // allowing the server to redirect to index.html for all routes
  // from that path.
  basename = getBasePath(window.location.pathname);
}

const history = createBrowserHistory({ basename });

// Middleware
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});
const middleware = [sagaMiddleware, routerMiddleware(history)];
const enhancers = composeEnhancers(applyMiddleware(...middleware));
const store = createStore(createRootReducer(history), enhancers);
sagaMiddleware.run(rootSaga);

// Check if user has a macaroon before we setup routes
store.dispatch(base.checkAuth());
store.dispatch(base.checkCrbsConfigured());

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.querySelector("#app")
);

/* eslint-disable import/prefer-default-export */
export { store };
